import React from 'react'
import { AllCardsType } from '../../../data/all-cards'
import { randomNumberInRange } from '../../../utils/functions'
import { useWidth } from '../../../hooks/useWidth'

const PhotoCards = ({ cards, mazo, tapiz }: { cards: AllCardsType[]; mazo: string; tapiz: string }) => {
    const width = useWidth()
    const translate = width >= 1280 ? 6 : 3

    return (
        <div className="relative mini:w-[80vw] mini:h-[52vh] md:h-fit xl:w-[30vw] xl:h-[84vh] after:bg-white-gradient after:absolute after:w-full after:h-full after:z-20 after:top-0 after-left-0 overflow-hidden">
            <div
                className={`absolute inset-[-240px] bg-cover`}
                style={{
                    transform: `rotate(${randomNumberInRange(-5, 5)}deg) translateY(${
                        randomNumberInRange(-40, 40) + 'px'
                    }) translateX(${randomNumberInRange(-40, 40) + 'px'})`,
                    backgroundImage: `url(/fondos/${tapiz}.jpg)`,
                }}
            ></div>
            <div className="relative grid w-full h-full grid-cols-5 place-items-center mini:pt-10 mini:pb-16 mini:px-10 xl:pt-16 xl:pb-28 xl:px-20">
                {cards.map((card: AllCardsType, index: number) => {
                    return (
                        <img
                            key={index}
                            src={require('../../../assets/' + mazo + card.url + '/' + card.image)}
                            className={
                                card.url === 'mayores'
                                    ? 'xl:w-[4vw] mini:w-[11vw] h-auto mini:rounded-sm xl:rounded-[7px]'
                                    : 'bg-white xl:w-[4vw] mini:w-[11vw] h-auto mini:rounded-sm xl:rounded-[7px]'
                            }
                            style={{
                                transform:
                                    'rotate(' +
                                    `${
                                        card.position !== 'invertida'
                                            ? randomNumberInRange(-5, 5)
                                            : randomNumberInRange(175, 185)
                                    }` +
                                    'deg) translateY(' +
                                    randomNumberInRange(-translate, translate) +
                                    'px',
                            }}
                            alt=""
                        />
                    )
                })}
            </div>
        </div>
    )
}

export default PhotoCards
